import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import {connect} from "react-redux";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {Button, MenuItem, Select} from "@material-ui/core";
import Util from "../../../custom/utils";
import {
  API,
  BASE_URL,
  BROKER_EMAIL,
  BROKER_EMAIL_LOGO,
  BROKER_EMAIL_MASTHEAD,
  BROKER_NAME,
  EMAIL_API,
  EMAIL_METHOD, ENABLED_LANGUAGES
} from "../../../../config";
import _ from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import Language from "@material-ui/icons/Language";

const axios = require('axios');
const investor = API.service('investors');

const styles = theme => ({
  sectionHeader:{
    position:'absolute',
    top:0,
    left:0,
    backgroundColor:'white',
    width: '100%',
    zIndex: 100,
    paddingTop: '5px',
  },
  tabs:{
    display:'inline-block',
    width:'100%',
    borderBottom:'2px solid #6a94ff',
    marginLeft:0,
    paddingLeft:0,

    '& li':{
      display:'inline-block',

      '& button':{
        margin:'1px',
        padding:'6px 12px',
        backgroundColor:'#383c42',
        color:'white'
      },
      '& button:hover':{
        backgroundColor:'#6a94ff',
      },
      '& button.active':{
        backgroundColor:'#6a94ff',
      }
    }
  },
  flex: {
    flex: 1,
  },
  full:{
    height: 'calc(100% - 15px)'
  },
  information_panel: {
    border:'1px solid #6e6e6e',
    background:'rgba(64,64,64,0.2)',
    margin:'10px',
    padding:'10px'
  }
});

class IntroEmail extends Component {
  state={
    activeTab:'usd',
    sent:false,
    langs: [
      ["en","English"],
      ["zh_CN","Simplified Chinese"],
      ["nl","Nederlands"]
    ],
    selectable: [],
    lang:false,
  };

  changeTab = (e) => {
    this.setState({
      activeTab:e.target.id
    })
  }

  changeLanguage = (event) => {
    this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
  }

  sendEmail = () => {
    const app = this;

    var password = Util.password(10);

    if(EMAIL_METHOD !== 'legacy'){
      axios.post(EMAIL_API + '/requests', {
        sender: 'Investor Portal',
        payload: {
          transportName: 'sendgrid',
          to: this.props.investor._email,
          from: BROKER_EMAIL,
          subject: 'Welcome to the ' + BROKER_NAME + ' investment platform',
          templateName: 'intro_email',
          language: this.state.lang.toLowerCase(),
          data: {
            broker_email: BROKER_EMAIL,
            broker_name: BROKER_NAME,
            base_url: BASE_URL,
            email_masthead: BROKER_EMAIL_MASTHEAD,
            email_logo: BROKER_EMAIL_LOGO,
            language: this.state.lang.toLowerCase(),
            clientName: this.props.investor._firstname + " " + this.props.investor._surname,
            user_id: this.props.investor._user_id,
            password: password,
            email:  this.props.investor._email,
          }
        }
      }).then(function (data) {
        console.log('Email Sent');
        app.setState({
          success: true,
          error: false,
        })
      })
    }
    var payload={
      '_password':password,
      '_force_reset':1,
    }

    investor.patch(this.props.investor._id,payload, {query:{type:'forgotPassword'}}).then(c=>{
      app.setState({
        sent:true
      })
    })
  }

  componentWillMount() {
    this.setState({
      selectable: ENABLED_LANGUAGES,
      lang: (this.props.investor._language === 'CN') ? 'zh_CN' : this.props.investor._language,
    })
  }

  render() {
    const {classes} = this.props;

    return (
      <Paper style={{position: 'relative', margin: 5}}>
        <AppBar position="static" elevation={0} color={"default"}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.flex}>
              Introductory Email
            </Typography>
          </Toolbar>
        </AppBar>
        <div style={{overflow: 'auto', height: '100%', padding: 5}}>
          <div className={classes.information_panel}>
            This will send the Introductory Email to the investor. If the investor has previously used the platform their password will be reset.
          </div>

          Language:
          <Select
            value={this.state.lang}
            onChange={this.changeLanguage}
            inputProps={{id: 'lang',name: 'lang'}}
            startAdornment={
              <InputAdornment position="start">
                <Language/>
              </InputAdornment>
            }
          >
            {this.state.langs.map((i) => {
              if(this.state.selectable.includes(i[0])){
                return (
                  <MenuItem value={i[0]}>{i[1]}</MenuItem>
                )
              } else {
                return false;
              }
            })}
          </Select><br/>
          <Button variant="contained" color="secondary" onClick={this.sendEmail}>Reset Password and Send Email</Button>
          {(this.state.sent === true) &&
          <i>Email Sent</i>
          }
        </div>
      </Paper>
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(IntroEmail))));
